import React from 'react';

import { Typography } from 'antd';

import type { ReportTone } from '../types';
import styles from './styles.module.less';

const { Text } = Typography;

export interface TimeMetricItem {
  key: string;
  label: string;
  value: React.ReactNode;
  detail: string;
  tone?: ReportTone;
}

/** Two-column grid of highlighted values with label and explanation. */
const TimeMetricsGrid: React.FC<{ items: TimeMetricItem[] }> = ({ items }) => (
  <div className={styles.grid}>
    {items.map(item => (
      <div className={styles.item} key={item.key}>
        <Text type="secondary">{item.label}</Text>
        <Text strong className={`${styles.value} ${styles[item.tone ?? 'primary']}`}>
          {item.value}
        </Text>
        <Text type="secondary">{item.detail}</Text>
      </div>
    ))}
  </div>
);

export default TimeMetricsGrid;
